import { useDroppable } from '@dnd-kit/core';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';

interface Props {
  stageId: number;
  title: string;
  count: number;
  children: ReactNode;
}

export function StageColumn({ stageId, title, count, children }: Props) {
  const { isOver, setNodeRef } = useDroppable({ id: stageId });

  return (
    <section
      className={clsx(
        'bg-subtle rounded-lg p-3 w-[280px] flex-shrink-0 flex flex-col h-full transition-all',
        isOver && 'ring-2 ring-accent ring-offset-2 ring-offset-canvas brightness-105'
      )}
    >
      <header className="flex items-center justify-between mb-3 px-1">
        <h2 className="font-serif text-sm font-medium text-ink-primary truncate">{title}</h2>
        <span className="text-xs text-ink-tertiary font-mono shrink-0 ml-2">{count}</span>
      </header>
      <div ref={setNodeRef} className="flex flex-col gap-2 flex-1 min-h-[100px] overflow-y-auto">
        {children}
      </div>
    </section>
  );
}
